import { HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CargandoService } from 'new-sysman-ui';
import { of } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Estado global persistente para el rastreo de peticiones.
 * Usamos un Set para asegurar que cada petición se cuente exactamente una vez,
 * evitando inconsistencias por concurrencia en módulos pesados como el Administrador.
 */
const activeRequests = new Set<HttpRequest<any>>();
let loaderVisible = false;

export const globalLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const loader = inject(CargandoService);

  // 1. Simulación de IP local (No afecta al contador de carga)
  if (req.url.toLowerCase().includes('ipify.org')) {
    const isLocal = window.location.hostname === 'localhost' || window.location.port === '4200';
    if (isLocal) {
      return of(new HttpResponse({ status: 200, body: { ip: '0.0.0.0' } }));
    }
  }

  // 2. Exclusiones técnicas mínimas (Evitan bucles durante la carga inicial de la App)
  // Nota: Ya no excluimos PQRS ni Administrador.
  const isTechnical =
    req.url.includes('assets/i18n') || req.url.includes('environment.json') || req.url.includes('getIp');

  if (isTechnical) {
    return next(req);
  }

  // 3. Registro de la petición
  activeRequests.add(req);

  // 4. Apertura inmediata si es la primera petición del lote
  if (activeRequests.size > 0 && !loaderVisible) {
    const msg = translate.instant('general.textosgenerales.txt_28_espereporfavor');
    const title = translate.instant('general.textosgenerales.txt_27_procesando');

    // Fallback síncrono por si las traducciones no están listas
    const finalMsg = msg !== 'general.textosgenerales.txt_28_espereporfavor' ? msg : 'Por favor espere...';
    const finalTitle = title !== 'general.textosgenerales.txt_27_procesando' ? title : 'Procesando';

    loader.abrir(finalMsg, finalTitle);
    loaderVisible = true;
  }

  return next(req).pipe(
    finalize(() => {
      // 5. Eliminación de la petición al finalizar (éxito, error o cancelación)
      activeRequests.delete(req);

      // 6. Cierre solo si ya no quedan peticiones pendientes
      if (activeRequests.size === 0 && loaderVisible) {
        loader.cerrar();
        loaderVisible = false;
      }
    }),
  );
};
